import { render, staticRenderFns } from "./SubmittedPosts.vue?vue&type=template&id=5ed5239e&"
import script from "./SubmittedPosts.vue?vue&type=script&lang=js&"
export * from "./SubmittedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports